function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MonitoringAccessService from '@/apps/data-platform/services/reports/monitoring_access';
export default {
  name: 'MyIncaMetrics',
  data: function data() {
    return {
      isLoading: false,
      selectedOption: 'current_month',
      dateOptions: [{
        text: 'Últimos 30 días',
        value: 'current_month'
      }, {
        text: 'Últimos 90 días',
        value: 'last_3_months'
      }, {
        text: 'Últimos 180 días',
        value: 'last_6_months'
      }, {
        text: 'Últimos 365 días',
        value: 'last_year'
      }],
      sections: [{
        identifier: 'data_management',
        desc: 'home_page_text.data_managment',
        color: 'rgb(13,55,255)',
        icon: 'icon-home_data_platform',
        metrics: [{
          title: 'access_requests',
          desc: 'home_page_text.access_requests',
          value: 0
        }, {
          title: 'access_granted',
          desc: 'home_page_text.acess_granted',
          value: 0
        }]
      }, {
        identifier: 'attribute_marketplace',
        desc: 'home_page_text.attribute_marketplace',
        color: 'rgb(98,0,234)',
        icon: 'icon-home_attribute',
        metrics: [{
          title: 'sandbox_created',
          desc: 'home_page_text.sandbox_created',
          value: 0
        }, {
          title: 'segments_exported',
          desc: 'home_page_text.segments_exported',
          value: 0
        }]
      }, {
        identifier: 'digital_audiences',
        desc: 'home_page_text.digital_audiences',
        color: 'rgb(0,207,207)',
        icon: 'icon-home_audience',
        metrics: [{
          title: 'created_audiences',
          desc: 'home_page_text.created_audiences',
          value: 0
        }]
      }, {
        identifier: 'customer_insights',
        desc: 'home_page_text.customer_insights',
        color: 'rgb(72,203,255)',
        icon: 'icon-home_insights',
        metrics: [{
          title: 'loaded_dataentries',
          desc: 'home_page_text.loaded_dataentries',
          value: 0
        }]
      }]
    };
  },
  created: function created() {
    this.loadInfo();
  },
  computed: {
    start_date: function start_date() {
      var today = new Date();
      today.setHours(0, 0, 0, 0);
      switch (this.selectedOption) {
        case 'current_month':
          return new Date(today.setDate(today.getDate() - 30));
        case 'last_3_months':
          return new Date(today.setDate(today.getDate() - 90));
        case 'last_6_months':
          return new Date(today.setDate(today.getDate() - 180));
        case 'last_year':
          return new Date(today.setDate(today.getDate() - 365));
        default:
          return null;
      }
    },
    end_date: function end_date() {
      var end = new Date();
      end.setHours(23, 59, 59, 999);
      return end;
    }
  },
  methods: {
    loadInfo: function loadInfo() {
      var _this = this;
      this.isLoading = true;
      var params = {
        'start_date': this.start_date,
        'end_date': this.end_date
      };
      MonitoringAccessService.myIncaMetrics(params).then(function (response) {
        console.log(response);
        var _iterator = _createForOfIteratorHelper(response.data),
          _step;
        try {
          var _loop = function _loop() {
            var sectionResponse = _step.value;
            var section = _this.sections.find(function (s) {
              return s.identifier === sectionResponse.identifier;
            });
            if (section) {
              var _iterator2 = _createForOfIteratorHelper(sectionResponse.metrics),
                _step2;
              try {
                var _loop2 = function _loop2() {
                  var metricResponse = _step2.value;
                  var metric = section.metrics.find(function (m) {
                    return m.title === metricResponse.title;
                  });
                  if (metric) {
                    metric.value = metricResponse.value;
                  }
                };
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  _loop2();
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
            }
          };
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            _loop();
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        _this.isLoading = false;
      }).catch(function (error) {
        console.log(error);
        _this.isLoading = false;
      });
    }
  }
};